import axios from '../../axios';
// 材料出库单列表
export const getStkOutMaterialPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialPage',
    method: 'post',
    data
  })
};
// 材料出库单总合计
export const getStkOutMaterialSum = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialSum',
    method: 'post',
    data
  })
};
// 材料出库单列表保存
export const saveStkOutMaterial = data => {
  return axios({
    url: '/api/sys/stk/saveStkOutMaterial',
    method: 'post',
    data
  })
};
// 材料出库单列表修改
export const updateStkOutMaterial = data => {
  return axios({
    url: '/api/sys/stk/updateStkOutMaterial',
    method: 'post',
    data
  })
};
// 材料出库单列表删除
export const deleteStkOutMaterials = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutMaterials',
    method: 'post',
    data
  })
};
// 材料出库单列表审
export const auditOutMaterial = data => {
  return axios({
    url: '/api/sys/stk/auditOutMaterial',
    method: 'post',
    data
  })
};
// 材料出库单列表作废
export const invalidOutMaterial = data => {
  return axios({
    url: '/api/sys/stk/invalidOutMaterial',
    method: 'post',
    data
  })
};
// 材料出库单明细列表
export const getStkOutMaterialEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialEntryPage',
    method: 'post',
    data
  })
};
// 材料出库单明细列表删除
export const deleteStkOutMaterialEntrys = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutMaterialEntrys',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/stk/MaterialIssueDoc.js